/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * TreePlotter v3 API
 * TreePlotter v3 API
 * OpenAPI spec version: 4.53.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  CreateTenant,
  CreateTenant201,
  GetTenantByIdParams,
  Id,
  InvalidIdProvidedResponse,
  JakartoCredentialInfo,
  SetTenantName,
  Tenant,
  TenantUserAssociation,
  UnauthorizedErrorResponse,
} from ".././model";

import { httpClient } from "../../../src/common/infrastructure/api/http-client";

/**
 * Fetch a list of tenants the user included in JWT has access to.
 * @summary Get tenants
 */
export const getTenants = (signal?: AbortSignal) => {
  return httpClient<Tenant[]>({
    url: `/query-service/tenant-information/get-tenants`,
    method: "GET",
    signal,
  });
};

export const getGetTenantsQueryKey = () => {
  return ["query-service", "tenant-information", "get-tenants"] as const;
};

export const getGetTenantsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTenants>>,
  TError = UnauthorizedErrorResponse
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getTenants>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTenantsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTenants>>> = ({
    signal,
  }) => getTenants(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTenants>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTenantsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTenants>>
>;
export type GetTenantsQueryError = UnauthorizedErrorResponse;

export function useGetTenants<
  TData = Awaited<ReturnType<typeof getTenants>>,
  TError = UnauthorizedErrorResponse
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTenants>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTenants>>,
          TError,
          Awaited<ReturnType<typeof getTenants>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTenants<
  TData = Awaited<ReturnType<typeof getTenants>>,
  TError = UnauthorizedErrorResponse
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTenants>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTenants>>,
          TError,
          Awaited<ReturnType<typeof getTenants>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTenants<
  TData = Awaited<ReturnType<typeof getTenants>>,
  TError = UnauthorizedErrorResponse
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTenants>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get tenants
 */

export function useGetTenants<
  TData = Awaited<ReturnType<typeof getTenants>>,
  TError = UnauthorizedErrorResponse
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTenants>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetTenantsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Fetch a list of tenants in TP3
 * @summary Get all tenants
 */
export const getAllTenants = (signal?: AbortSignal) => {
  return httpClient<Tenant[]>({
    url: `/admin/query-service/tenant-information/get-tenants`,
    method: "GET",
    signal,
  });
};

export const getGetAllTenantsQueryKey = () => {
  return [
    "admin",
    "query-service",
    "tenant-information",
    "get-tenants",
  ] as const;
};

export const getGetAllTenantsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAllTenants>>,
  TError = UnauthorizedErrorResponse
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getAllTenants>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAllTenantsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllTenants>>> = ({
    signal,
  }) => getAllTenants(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAllTenants>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAllTenantsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAllTenants>>
>;
export type GetAllTenantsQueryError = UnauthorizedErrorResponse;

export function useGetAllTenants<
  TData = Awaited<ReturnType<typeof getAllTenants>>,
  TError = UnauthorizedErrorResponse
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAllTenants>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllTenants>>,
          TError,
          Awaited<ReturnType<typeof getAllTenants>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAllTenants<
  TData = Awaited<ReturnType<typeof getAllTenants>>,
  TError = UnauthorizedErrorResponse
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAllTenants>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllTenants>>,
          TError,
          Awaited<ReturnType<typeof getAllTenants>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAllTenants<
  TData = Awaited<ReturnType<typeof getAllTenants>>,
  TError = UnauthorizedErrorResponse
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAllTenants>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get all tenants
 */

export function useGetAllTenants<
  TData = Awaited<ReturnType<typeof getAllTenants>>,
  TError = UnauthorizedErrorResponse
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAllTenants>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAllTenantsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Fetch a tenant by tenant ID.
 * @summary Get tenants
 */
export const getTenantById = (
  params: GetTenantByIdParams,
  signal?: AbortSignal
) => {
  return httpClient<Tenant>({
    url: `/query-service/tenant-information/get-tenant`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetTenantByIdQueryKey = (params?: GetTenantByIdParams) => {
  return [
    "query-service",
    "tenant-information",
    "get-tenant",
    ...(params ? [params] : []),
  ] as const;
};

export const getGetTenantByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getTenantById>>,
  TError = UnauthorizedErrorResponse | void
>(
  params: GetTenantByIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTenantById>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTenantByIdQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTenantById>>> = ({
    signal,
  }) => getTenantById(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTenantById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTenantByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTenantById>>
>;
export type GetTenantByIdQueryError = UnauthorizedErrorResponse | void;

export function useGetTenantById<
  TData = Awaited<ReturnType<typeof getTenantById>>,
  TError = UnauthorizedErrorResponse | void
>(
  params: GetTenantByIdParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTenantById>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTenantById>>,
          TError,
          Awaited<ReturnType<typeof getTenantById>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTenantById<
  TData = Awaited<ReturnType<typeof getTenantById>>,
  TError = UnauthorizedErrorResponse | void
>(
  params: GetTenantByIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTenantById>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTenantById>>,
          TError,
          Awaited<ReturnType<typeof getTenantById>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTenantById<
  TData = Awaited<ReturnType<typeof getTenantById>>,
  TError = UnauthorizedErrorResponse | void
>(
  params: GetTenantByIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTenantById>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get tenants
 */

export function useGetTenantById<
  TData = Awaited<ReturnType<typeof getTenantById>>,
  TError = UnauthorizedErrorResponse | void
>(
  params: GetTenantByIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTenantById>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetTenantByIdQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns whether the tenant has a Jakarto API key configured, and the key itself
if so. A tenant with no jakartoSecretArn set returns { configured: false }, which
is a normal, expected response. If the tenant has an ARN set but the underlying
secret could not be retrieved from Secrets Manager, a 500 is returned instead of
{ configured: false } — that case indicates drift or an AWS-side failure.

 * @summary Get a tenant's configured Jakarto credential, if any
 */
export const getJakartoCredential = (tenantId: Id, signal?: AbortSignal) => {
  return httpClient<JakartoCredentialInfo>({
    url: `/query-service/tenant-information/tenant/${tenantId}/jakarto-credential`,
    method: "GET",
    signal,
  });
};

export const getGetJakartoCredentialQueryKey = (tenantId?: Id) => {
  return [
    "query-service",
    "tenant-information",
    "tenant",
    tenantId,
    "jakarto-credential",
  ] as const;
};

export const getGetJakartoCredentialQueryOptions = <
  TData = Awaited<ReturnType<typeof getJakartoCredential>>,
  TError = UnauthorizedErrorResponse | void | InvalidIdProvidedResponse
>(
  tenantId: Id,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getJakartoCredential>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetJakartoCredentialQueryKey(tenantId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getJakartoCredential>>
  > = ({ signal }) => getJakartoCredential(tenantId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!tenantId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getJakartoCredential>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetJakartoCredentialQueryResult = NonNullable<
  Awaited<ReturnType<typeof getJakartoCredential>>
>;
export type GetJakartoCredentialQueryError =
  | UnauthorizedErrorResponse
  | void
  | InvalidIdProvidedResponse;

export function useGetJakartoCredential<
  TData = Awaited<ReturnType<typeof getJakartoCredential>>,
  TError = UnauthorizedErrorResponse | void | InvalidIdProvidedResponse
>(
  tenantId: Id,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getJakartoCredential>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getJakartoCredential>>,
          TError,
          Awaited<ReturnType<typeof getJakartoCredential>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetJakartoCredential<
  TData = Awaited<ReturnType<typeof getJakartoCredential>>,
  TError = UnauthorizedErrorResponse | void | InvalidIdProvidedResponse
>(
  tenantId: Id,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getJakartoCredential>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getJakartoCredential>>,
          TError,
          Awaited<ReturnType<typeof getJakartoCredential>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetJakartoCredential<
  TData = Awaited<ReturnType<typeof getJakartoCredential>>,
  TError = UnauthorizedErrorResponse | void | InvalidIdProvidedResponse
>(
  tenantId: Id,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getJakartoCredential>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get a tenant's configured Jakarto credential, if any
 */

export function useGetJakartoCredential<
  TData = Awaited<ReturnType<typeof getJakartoCredential>>,
  TError = UnauthorizedErrorResponse | void | InvalidIdProvidedResponse
>(
  tenantId: Id,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getJakartoCredential>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetJakartoCredentialQueryOptions(tenantId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a tenant
 * @summary Create tenant
 */
export const createTenant = (
  createTenant: CreateTenant,
  signal?: AbortSignal
) => {
  return httpClient<CreateTenant201 | void>({
    url: `/admin/command-service/tenant/aggregate/tenant/create-tenant`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createTenant,
    signal,
  });
};

export const getCreateTenantMutationOptions = <
  TError = void | UnauthorizedErrorResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTenant>>,
    TError,
    { data: CreateTenant },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTenant>>,
  TError,
  { data: CreateTenant },
  TContext
> => {
  const mutationKey = ["createTenant"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTenant>>,
    { data: CreateTenant }
  > = (props) => {
    const { data } = props ?? {};

    return createTenant(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTenantMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTenant>>
>;
export type CreateTenantMutationBody = CreateTenant;
export type CreateTenantMutationError = void | UnauthorizedErrorResponse;

/**
 * @summary Create tenant
 */
export const useCreateTenant = <
  TError = void | UnauthorizedErrorResponse,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createTenant>>,
      TError,
      { data: CreateTenant },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createTenant>>,
  TError,
  { data: CreateTenant },
  TContext
> => {
  const mutationOptions = getCreateTenantMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const setTenantName = (
  tenantId: Id,
  setTenantName: SetTenantName,
  signal?: AbortSignal
) => {
  return httpClient<Tenant>({
    url: `/command-service/tenant/aggregate/tenant/${tenantId}/set-tenant-name`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: setTenantName,
    signal,
  });
};

export const getSetTenantNameMutationOptions = <
  TError = UnauthorizedErrorResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setTenantName>>,
    TError,
    { tenantId: Id; data: SetTenantName },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setTenantName>>,
  TError,
  { tenantId: Id; data: SetTenantName },
  TContext
> => {
  const mutationKey = ["setTenantName"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setTenantName>>,
    { tenantId: Id; data: SetTenantName }
  > = (props) => {
    const { tenantId, data } = props ?? {};

    return setTenantName(tenantId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetTenantNameMutationResult = NonNullable<
  Awaited<ReturnType<typeof setTenantName>>
>;
export type SetTenantNameMutationBody = SetTenantName;
export type SetTenantNameMutationError = UnauthorizedErrorResponse;

export const useSetTenantName = <
  TError = UnauthorizedErrorResponse,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof setTenantName>>,
      TError,
      { tenantId: Id; data: SetTenantName },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof setTenantName>>,
  TError,
  { tenantId: Id; data: SetTenantName },
  TContext
> => {
  const mutationOptions = getSetTenantNameMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const associateUserToTenant = (
  tenantId: Id,
  tenantUserAssociation: TenantUserAssociation,
  signal?: AbortSignal
) => {
  return httpClient<Tenant>({
    url: `/admin/command-service/tenant/aggregate/tenant/${tenantId}/associate-user`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: tenantUserAssociation,
    signal,
  });
};

export const getAssociateUserToTenantMutationOptions = <
  TError = UnauthorizedErrorResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof associateUserToTenant>>,
    TError,
    { tenantId: Id; data: TenantUserAssociation },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof associateUserToTenant>>,
  TError,
  { tenantId: Id; data: TenantUserAssociation },
  TContext
> => {
  const mutationKey = ["associateUserToTenant"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof associateUserToTenant>>,
    { tenantId: Id; data: TenantUserAssociation }
  > = (props) => {
    const { tenantId, data } = props ?? {};

    return associateUserToTenant(tenantId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssociateUserToTenantMutationResult = NonNullable<
  Awaited<ReturnType<typeof associateUserToTenant>>
>;
export type AssociateUserToTenantMutationBody = TenantUserAssociation;
export type AssociateUserToTenantMutationError = UnauthorizedErrorResponse;

export const useAssociateUserToTenant = <
  TError = UnauthorizedErrorResponse,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof associateUserToTenant>>,
      TError,
      { tenantId: Id; data: TenantUserAssociation },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof associateUserToTenant>>,
  TError,
  { tenantId: Id; data: TenantUserAssociation },
  TContext
> => {
  const mutationOptions = getAssociateUserToTenantMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const dissociateUserFromTenant = (
  tenantId: Id,
  tenantUserAssociation: TenantUserAssociation,
  signal?: AbortSignal
) => {
  return httpClient<Tenant>({
    url: `/admin/command-service/tenant/aggregate/tenant/${tenantId}/dissociate-user`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: tenantUserAssociation,
    signal,
  });
};

export const getDissociateUserFromTenantMutationOptions = <
  TError = UnauthorizedErrorResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dissociateUserFromTenant>>,
    TError,
    { tenantId: Id; data: TenantUserAssociation },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dissociateUserFromTenant>>,
  TError,
  { tenantId: Id; data: TenantUserAssociation },
  TContext
> => {
  const mutationKey = ["dissociateUserFromTenant"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dissociateUserFromTenant>>,
    { tenantId: Id; data: TenantUserAssociation }
  > = (props) => {
    const { tenantId, data } = props ?? {};

    return dissociateUserFromTenant(tenantId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type DissociateUserFromTenantMutationResult = NonNullable<
  Awaited<ReturnType<typeof dissociateUserFromTenant>>
>;
export type DissociateUserFromTenantMutationBody = TenantUserAssociation;
export type DissociateUserFromTenantMutationError = UnauthorizedErrorResponse;

export const useDissociateUserFromTenant = <
  TError = UnauthorizedErrorResponse,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof dissociateUserFromTenant>>,
      TError,
      { tenantId: Id; data: TenantUserAssociation },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof dissociateUserFromTenant>>,
  TError,
  { tenantId: Id; data: TenantUserAssociation },
  TContext
> => {
  const mutationOptions = getDissociateUserFromTenantMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const disableTenant = (tenantId: Id, signal?: AbortSignal) => {
  return httpClient<void>({
    url: `/admin/command-service/tenant/aggregate/tenant/${tenantId}/disable-tenant`,
    method: "POST",
    signal,
  });
};

export const getDisableTenantMutationOptions = <
  TError = UnauthorizedErrorResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof disableTenant>>,
    TError,
    { tenantId: Id },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof disableTenant>>,
  TError,
  { tenantId: Id },
  TContext
> => {
  const mutationKey = ["disableTenant"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof disableTenant>>,
    { tenantId: Id }
  > = (props) => {
    const { tenantId } = props ?? {};

    return disableTenant(tenantId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DisableTenantMutationResult = NonNullable<
  Awaited<ReturnType<typeof disableTenant>>
>;

export type DisableTenantMutationError = UnauthorizedErrorResponse;

export const useDisableTenant = <
  TError = UnauthorizedErrorResponse,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof disableTenant>>,
      TError,
      { tenantId: Id },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof disableTenant>>,
  TError,
  { tenantId: Id },
  TContext
> => {
  const mutationOptions = getDisableTenantMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Same underlying data as getJakartoCredential, exposed for TP2/api-v2 service-to-service
calls. A tenant with no jakartoSecretArn set returns { configured: false }. If the
tenant has an ARN set but the secret could not be retrieved from Secrets Manager, a
500 is returned instead of { configured: false }.

 * @summary Get a tenant's configured Jakarto credential, if any (TP2 service-to-service)
 */
export const getJakartoCredentialTp2 = (tenantId: Id, signal?: AbortSignal) => {
  return httpClient<JakartoCredentialInfo>({
    url: `/command-service/tenant/service/tp2-interop/${tenantId}/jakarto-credential`,
    method: "GET",
    signal,
  });
};

export const getGetJakartoCredentialTp2QueryKey = (tenantId?: Id) => {
  return [
    "command-service",
    "tenant",
    "service",
    "tp2-interop",
    tenantId,
    "jakarto-credential",
  ] as const;
};

export const getGetJakartoCredentialTp2QueryOptions = <
  TData = Awaited<ReturnType<typeof getJakartoCredentialTp2>>,
  TError = UnauthorizedErrorResponse | InvalidIdProvidedResponse | void
>(
  tenantId: Id,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getJakartoCredentialTp2>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetJakartoCredentialTp2QueryKey(tenantId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getJakartoCredentialTp2>>
  > = ({ signal }) => getJakartoCredentialTp2(tenantId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!tenantId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getJakartoCredentialTp2>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetJakartoCredentialTp2QueryResult = NonNullable<
  Awaited<ReturnType<typeof getJakartoCredentialTp2>>
>;
export type GetJakartoCredentialTp2QueryError =
  | UnauthorizedErrorResponse
  | InvalidIdProvidedResponse
  | void;

export function useGetJakartoCredentialTp2<
  TData = Awaited<ReturnType<typeof getJakartoCredentialTp2>>,
  TError = UnauthorizedErrorResponse | InvalidIdProvidedResponse | void
>(
  tenantId: Id,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getJakartoCredentialTp2>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getJakartoCredentialTp2>>,
          TError,
          Awaited<ReturnType<typeof getJakartoCredentialTp2>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetJakartoCredentialTp2<
  TData = Awaited<ReturnType<typeof getJakartoCredentialTp2>>,
  TError = UnauthorizedErrorResponse | InvalidIdProvidedResponse | void
>(
  tenantId: Id,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getJakartoCredentialTp2>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getJakartoCredentialTp2>>,
          TError,
          Awaited<ReturnType<typeof getJakartoCredentialTp2>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetJakartoCredentialTp2<
  TData = Awaited<ReturnType<typeof getJakartoCredentialTp2>>,
  TError = UnauthorizedErrorResponse | InvalidIdProvidedResponse | void
>(
  tenantId: Id,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getJakartoCredentialTp2>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get a tenant's configured Jakarto credential, if any (TP2 service-to-service)
 */

export function useGetJakartoCredentialTp2<
  TData = Awaited<ReturnType<typeof getJakartoCredentialTp2>>,
  TError = UnauthorizedErrorResponse | InvalidIdProvidedResponse | void
>(
  tenantId: Id,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getJakartoCredentialTp2>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetJakartoCredentialTp2QueryOptions(
    tenantId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
